import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign } from '@aslanpay/portal-common-lib';

const usePublishCampaign = (options: UseMutationOptions<Campaign, Error, string>) => {
  return useMutation<Campaign, Error, string>(
    (campaignId) => campaignsService.publishCampaign(campaignId),
    options
  );
};

export default usePublishCampaign;
